// extracted by mini-css-extract-plugin
export default {"profileLayout":"profile_profileLayout__eU4gX","iconLayout":"profile_iconLayout__ywaQQ","icon":"profile_icon__dfN2m"};